import { useState, FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { createSearchParams } from 'react-router-dom';
import { verifyEmail } from 'pages/password-reset/actions';
import { useDispatch } from 'react-redux';
import toggleNotification from 'actions/notifications';
import i18n from 'i18n';
import EmailForm from 'pages/password-reset/components/EmailForm';
import Wrapper from 'pages/password-reset/components/Wrapper';
import { VpnKeyOutlined } from '@material-ui/icons';
import validator from 'validator';

const PasswordReset: FunctionComponent = () => {
  const [isLoading, toggleLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSave = (email: string) => {
    if (!validator.isEmail(email)) {
      dispatch(
        toggleNotification(i18n.t('pages.signup.formError.email'), 'error')
      );
      return;
    }

    toggleLoading(true);
    verifyEmail(email)
      .then(() => {
        toggleLoading(false);
        navigate({
          pathname: `/password-reset/check${email ? '?' : ''}`,
          search: createSearchParams({ email }).toString()
        });
      })
      .catch(() => {
        toggleLoading(false);
        dispatch(toggleNotification(i18n.t('notifications.apiError'), 'error'));
      });
  };

  return (
    <Wrapper
      icon={<VpnKeyOutlined />}
      title={i18n.t('pages.passwordReset.main.title')}
      subtitle={i18n.t('pages.passwordReset.main.subtitle')}
    >
      <EmailForm onSave={onSave} isLoading={isLoading} />
    </Wrapper>
  );
};

export default PasswordReset;
